const ALWAYS_MANAGE_EMAILS = new Set(['shaun@digitalflux.co.za']);

export function readTokenClaims(token) {
  try {
    if (!token) return null;
    const parts = String(token).split('.');
    if (!parts[1]) return null;
    const padded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

export function tokenCanManageUsers(token) {
  const claims = readTokenClaims(token);
  if (!claims) return false;
  const email = String(claims.email || '').trim().toLowerCase();
  return claims.role === 'admin' || ALWAYS_MANAGE_EMAILS.has(email);
}

export function accountAlwaysManagesUsers(user) {
  if (!user) return false;
  const email = String(user.email || '').trim().toLowerCase();
  return user.role === 'admin' || ALWAYS_MANAGE_EMAILS.has(email);
}
